(ns core.front.icons
  "Cloudpermit icons are saved in /vaahtera/core/src/svg

  Required information for icon .svg files are <title> and <path> tags.
  If instead of paths the .svg contains shapes they need to be converted to paths
  with Inkscape's Object to Path or similar functionality."
  (:require-macros [core.front.macros :as macros])
  (:refer-clojure :exclude [map remove print list comment])
  (:require [clojure.string :as str]))

(declare add-area add-circle add-path add-point archives archives-in
         arrow-down arrow-left arrow-right arrow-up arrows
         arrows-left-right arrows-up-down bell bell-off bookmark building
         building-plus calendar check checkbox-off checkbox-on
         checkbox-partial chevron-bottom chevron-down chevron-end
         chevron-left chevron-right chevron-small-down chevron-small-left
         chevron-small-right chevron-small-up chevron-small-up-down
         chevron-start chevron-top chevron-up circle circle-arrow-down
         circle-arrow-left circle-arrow-right circle-arrow-up circle-attention
         circle-check circle-dash circle-info circle-minus circle-pen
         circle-plus circle-question circle-remove circle-section-sign
         circle-stamp circle-star clock collapse comment conversation copy
         dependency document document-list document-plus document-search document-section-sign documents
         download envelope envelope-off excavator expand external-link eye eye-off facebook
         file file-check filters flag folder gear google-plus grip-diagonal
         grip-horizontal grip-vertical hammer heart helmet house instagram
         laptop layers lightbulb link list location location-plus lock
         lock-open lock-open-fully log-in log-out map map-marker-primary measure measure-area
         megaphone menu minus nova novacloud paperclip pen persons phone plus presentation
         print quote radio-off radio-on recommend redo refresh refresh-section-sign refresh-envelope
         remove rotate-left rotate-right save search shopping-cart stamp
         star trash tree tree-path twitter undersign undo upload user
         user-pen user-plus viewfinder warning world youtube zoom-in
         zoom-in-area zoom-out draggable stop-filled collapse-up-left
         download-map expand-down-right select-point upload-polygon square-foot square-meter
         work-order-24)

(macros/def-icons)

(defn icon->img-svg-src
  ([icon-data]
   (icon->img-svg-src icon-data nil))
  ([icon-data fill]
   (icon->img-svg-src icon-data fill true))
  ([{:keys [width height view-box svg-data] :as icon-data} fill with-data-def?]
   (when-not svg-data
     (throw (ex-info "Invalid icon definition" icon-data)))
   (str (when with-data-def? "data:image/svg+xml;utf8,")
        "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"" width
        "\" height=\"" height "\" viewBox=\"" view-box "\">"
        (->> svg-data
             :paths
             (clojure.core/map #(str "<path d=\"" (:d %) "\"" (when fill (str " fill=\"" fill "\"")) "></path>"))
             str/join)
        "</svg>")))
